module.exports = __webpack_public_path__ + "static/media/etn.4dfbc846.svg";